import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { OptionType } from '@/modules/common/types';

interface FilterSelectProps {
  options: OptionType[];
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const FilterSelect = ({
  options,
  label,
  value,
  onChange,
}: FilterSelectProps) => {
  return (
    <Select onValueChange={onChange} value={value} key={value}>
      <SelectTrigger
        value={value}
        onReset={() => onChange('')}
        className="relative flex items-center justify-between h-[37px] rounded-lg border border-gray-700 bg-black text-white shadow-sm hover:bg-zinc-900"
      >
        <span className="flex items-center space-x-1 [&>span]:capitalize [&>span]:truncate [&>span:last-child]:pr-4">
          <span className="text-zinc-500">{label}:</span>
          {value ? (
            <SelectValue
              aria-label={value}
              className="text-zinc-50 data-[placeholder]:text-zinc-50 data-[placeholder]:capitalize"
              placeholder={label}
            />
          ) : (
            <span className="text-zinc-50 data-[placeholder]:text-zinc-50">
              All
            </span>
          )}
        </span>
      </SelectTrigger>
      <SelectContent className="bg-black text-white border border-zinc-800 rounded-lg">
        {options.map((option) => (
          <SelectItem key={option.id} value={option.id} className="capitalize">
            {option.value}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
